module.exports = __webpack_public_path__ + "assets/img/Large.a3b997a2.svg";